import isEqual from 'lodash-es/isEqual'
import React from 'react'

import { FilterDropdown } from '@components/common/FilterDropdown'
import { Checkbox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import * as S from './PromotionCodesFilter.styled'
import type { FormValues } from './PromotionCodesFilter.types'
import { useFilterPromotionCodes } from './hooks/useFilterPromotionCodes'

export const PromotionCodesFilter = () => {
  const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } =
    useFilterPromotionCodes()

  const handleSubmit = (values: FormValues) => {
    setFiltersParams({
      creationReason: values.showGiftRedemptions ? 'MANUAL,FROM_GIFT' : undefined,
    })
  }

  const formik = useFormik<FormValues>({
    initialValues: {
      showGiftRedemptions: isEqual(filtersParams.creationReason, 'MANUAL,FROM_GIFT'),
    },
    onSubmit: handleSubmit,
  })

  const handleReset = () => {
    formik.resetForm()
    resetFiltersParams()
  }

  return (
    <FilterDropdown
      content={
        <S.Form>
          <S.FormRow>
            <Checkbox
              label="Show gift redemptions"
              {...formik.getFieldProps('showGiftRedemptions')}
            />
          </S.FormRow>
        </S.Form>
      }
      activityIndicator={hasFilterParams}
      onSubmit={formik.handleSubmit}
      onReset={handleReset}
    />
  )
}
